'use client';
import { CloudinaryType, TypeBlockLogoGrid } from '@fm-nx/contentful-types';
import ClientLogo from '../client-logo/client-logo';
import styles from './client-logo-grid.module.css';
import AnimationFadeLazy from '../animation-fade-lazy/animation-fade-lazy';
import { variantsChildren } from '../__constants__/animation-variants';
import { LazyMotion, m as motion } from 'framer-motion';

const loadFeatures = () => import('../__constants__/framer-features').then((res) => res.default);

type ClientLogoGridsPropTypes = {
    blockLogoGrid: TypeBlockLogoGrid<'WITHOUT_UNRESOLVABLE_LINKS'>;
    mode?: 'light' | 'dark';
};

export const ClientLogoGrid = (props: ClientLogoGridsPropTypes) => {
    const { blockLogoGrid, mode } = props;
    const { fields } = blockLogoGrid;
    if (!fields) return null;

    const { logosCloudinary } = fields;

    if (!Array.isArray(logosCloudinary) || logosCloudinary.length === 0) return null;

    return (
        <AnimationFadeLazy>
            <div className="w-full mx-auto max-w-container">
                <div className="py-20 mx-6 md:mx-0">
                    <div className="flex flex-col md:grid md:grid-cols-14 md:gap-4">
                        <div className="col-span-14 md:col-span-12 md:col-start-2">
                            <div className={styles['grid-logo']}>
                                {(logosCloudinary as CloudinaryType[]).map((cloudImg) => {
                                    if (!cloudImg) return null;
                                    return (
                                        <LazyMotion features={loadFeatures} key={cloudImg.public_id}>
                                            <motion.div variants={variantsChildren}>
                                                <ClientLogo image={cloudImg} mode={mode} />
                                            </motion.div>
                                        </LazyMotion>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AnimationFadeLazy>
    );
};
export default ClientLogoGrid;
